module.exports = __webpack_public_path__ + "static/media/tier-5.a97dc718.jpg";